var utils = require('./sv-jedesheim.utils.js');
var ajax = require('./sv-jedesheim.ajax.js');
var initialize = require('./sv-jedesheim.initialize.js');

function validatorMethods() {

	$.validator.prototype.resetForm = function () {
		if ($.fn.resetForm) {
			$(this.currentForm).resetForm();
		}
		$(this.currentForm)[0].reset();
		this.submitted = {};
		this.lastElement = null;
		this.prepareForm();
		this.hideErrors();
		var elements = this.elements().removeData("previousValue").removeAttr("aria-invalid");
		if (this.settings.unhighlight) {
			for (var i = 0; elements[i]; i++) {
				this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
			}
		}
	}

	$.validator.addMethod(
		"minNonAlpha",
		function (value, element, param) {

			var count = 0;
			var array = value.split("");
			jQuery.each(array, function (i, val) {
				if (!/^[a-zA-Z]+$/.test(val)) {
					count++;
				}
			});
			return this.optional(element) || count >= param;
		},
		Lang.get('sv-jedesheim.field_non_alpha', { "min": "{0}" })
	);

	$.validator.addMethod(
		"validText",
		function (value, element, param) {
			var valid = true;

			var pattern = new RegExp("^[" + param + "]+$");
			var array = value.split("");
			jQuery.each(array, function (i, val) {
				if (pattern.test(val)) {
					valid = false;
					return;
				}
			});

			pattern = null;
			return this.optional(element) || valid;
		},
		Lang.get('sv-jedesheim.no_valid_text', { "characters": "{0}" })
	);

	$.validator.addMethod(
		"validUsername",
		function (value, element) {

			if (/^[-_\.]+$/.test(value)) {
				return false;
			}

			return this.optional(element) || /^[a-zA-Z0-9-_\.]+$/.test(value);
		},
		Lang.get('sv-jedesheim.no_valid_username')
	);

	$.validator.addMethod(
		"uniqueName",
		function (value, element) {
			var attrAction = element.getAttribute('data-action');
			if (utils.isUndefined(attrAction)) {
				return false;
			}

			var data = null;
			var attrOrigValue = element.getAttribute('data-orig-value');
			if (!utils.isUndefined(attrOrigValue)) {
				data = "origValue=" + encodeURIComponent(attrOrigValue);
			}

			return $.validator.methods.remote.call(this, value, element, {
				url: attrAction + "/" + value,
				data: data
			});
		},
		'TODO'
	);

	$.validator.addMethod(
		"validDateRange",
		function (value, element, param) {
			var valid = true;

			var date_from = null;
			if ($(element).parents('form').find(param[0]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				date_from = $(element).parents('form').find(param[0]).data('picker').getDate();
			}
			var date_till = null;
			if ($(element).parents('form').find(param[1]).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				date_till = $(element).parents('form').find(param[1]).data('picker').getDate();
			}

			if (!utils.isUndefined(date_from) && !utils.isUndefined(date_till)
				&& date_from > date_till)
			{
				return false;
			}

			return true;
		},
		Lang.get('sv-jedesheim.invalid_date_range')
	);

	$.validator.addMethod(
		"maxDate",
		function (value, element, param) {

			var date = $(element).data('picker').getDate();

			if (!utils.isUndefined(date) && date > param) {
				return false;
			}

			return true;
		},
		'TODO'
	);

	$.validator.addMethod(
		"requireFromGroup",
		function (value, element, param) {
			var valid = false;

			var elements = $(element).parents('.modal-dialog').find(param[1]);

			var counter = 0;
			jQuery.each(elements, function (i, val) {
				if ($(val).is('.tt-validation-checkbox')) {
					if ($(val)[0].checked) {
						counter++;
					}
				} else if ($(val).is('.tt-select2')) {
					if (!utils.isUndefined($(val).select2('val')) && ($(val).select2('val').length > 1 || ($(val).select2('val').length === 1 && $(val).select2('val')[0] !== ''))) {
						counter++;
					}
				} else if ($(val).is('.datepicker')) {
					if ($(val).select2('val').length > 1 || ($(val).select2('val').length === 1 && $(val).select2('val')[0].value !== '')) {
						counter++;
					}
				} else {
					if ($(val).val() !== '') {
						counter++;
					}
				}
			});

			if (counter >= param[0]) {
				valid = true;
			}

			return valid;
		},
		Lang.get('sv-jedesheim.element_from_group_is_required')
	);

	$.validator.addMethod(
		"requireFromGroupWhenElementFilled",
		function (value, element, param) {

			var valid = true;

			var elements = $(element).parents('.tt-content-dialog,.tt-content-detail').find(param[0]);

			if ($(elements[0]).hasClass('tt-validation-checkbox') || $(elements[0]).hasClass('tt-validation-radio')) {
				if ($(elements[0])[0].checked && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else if ($(elements[0]).hasClass('tt-select2')) {
				if (!utils.isUndefined($(elements[0]).select2('val')) && ($(elements[0]).select2('val').length > 1 || ($(elements[0]).select2('val').length === 1 && $(elements[0]).select2('val')[0] !== '')) && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else if ($(elements[0]).hasClass('datepicker')) {
				if (($(elements[0]).select2('val').length > 1 || ($(elements[0]).select2('val').length === 1 && $(elements[0]).select2('val')[0].value !== '')) && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else {
				if ($(elements[0]).val() !== '' && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			}

			if (!valid) {
				valid = false;
				var elements = $(element).parents('.tt-content-dialog').find(param[2]);

				var counter = 0;
				jQuery.each(elements, function (i, val) {
					if ($(val).is('.tt-validation-checkbox')) {
						if ($(val)[0].checked) {
							counter++;
						}
					} else if ($(val).is('.tt-select2')) {
						if (!utils.isUndefined($(elements[0]).select2('val')) && ($(val).select2('val').length > 1 || ($(val).select2('val').length === 1 && $(val).select2('val')[0] !== ''))) {
							counter++;
						}
					} else if ($(val).is('.datepicker')) {
						if ($(val).select2('val').length > 1 || ($(val).select2('val').length === 1 && $(val).select2('val')[0].value !== '')) {
							counter++;
						}
					} else {
						if ($(val).val() !== '') {
							counter++;
						}
					}
				});

				if (counter >= param[1]) {
					valid = true;
				}
			}

			return valid;
		},
		Lang.get('sv-jedesheim.element_from_group_is_required')
	);

	$.validator.addMethod(
		"requiredWhenElementFilled",
		function (value, element, param) {
			var valid = true;

			var elements = $(element).parents('form').find(param[0]);

			if ($(elements[0]).hasClass('tt-validation-checkbox') || $(elements[0]).hasClass('tt-validation-radio')) {
				if ($(elements[0])[0].checked && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else if ($(elements[0]).hasClass('tt-select2')) {
				if (!utils.isUndefined($(elements[0]).select2('val')) && ($(elements[0]).select2('val').length > 1 || ($(elements[0]).select2('val').length === 1 && $(elements[0]).select2('val')[0] !== '')) && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else if ($(elements[0]).hasClass('datepicker')) {
				if (($(elements[0]).select2('val').length > 1 || ($(elements[0]).select2('val').length === 1 && $(elements[0]).select2('val')[0].value !== '')) && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			} else {
				if ($(elements[0]).val() !== '' && (value === '' || utils.isUndefined(value))) {
					valid = false;
				}
			}

			return valid;
		},
		'TODO'
	);

	$.validator.addMethod(
		"minLocale",
		function (value, element, param) {
			var valid = true;

			try {
				var number = utils.stringToNumber(value);
				if (number < param) {
					valid = false;
				}

			} catch (NaNError) {
				valid = false;
			}

			return valid;
		},
		Lang.get('sv-jedesheim.invalid_float')
	);

	$.validator.addMethod(
		"maxLocale",
		function (value, element, param) {
			var valid = true;

			try {
				var number = utils.stringToNumber(value);
				if (number > param) {
					valid = false;
				}

			} catch (NaNError) {
				valid = false;
			}

			return valid;
		},
		Lang.get('sv-jedesheim.invalid_float')
	);

	$.validator.addMethod(
		"validFloatDecimalPlaces",
		function (value, element, param) {
			var valid = true;

			try {
				var splittedNumber = value.split(utils.getDecimalSeparator());
				if (splittedNumber.length === 2 && utils.stringToNumber(splittedNumber[0]) <= utils.stringToNumber(splittedNumber[1]) + 1) {
					valid = false;
				}

			} catch (NaNError) {
				valid = false;
			}

			return valid;
		},
		Lang.get('sv-jedesheim.invalid_float')
	);

	$.validator.addMethod(
		"requiredDateFormat",
		function (value, element, param) {

			var selectedValue = $(element).select2('val');

			if (jQuery.inArray('full', selectedValue) !== -1 || jQuery.inArray('mm/yy', selectedValue) !== -1 || jQuery.inArray('yy', selectedValue) !== -1)
			{
				return true;
			}
			return false;
		},
		Lang.get('sv-jedesheim.element_from_group_is_required')
	);

	$.validator.addMethod(
		'validDate',
		function(value, element, params) {
			if (value.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
				var picker = $(element).data('picker');

				return moment(value.replace(/_/g, ''), picker._o.format).isValid();
			}
			return true;
		},
		Lang.get('sv-jedesheim.invalid_date')
	);

	$.validator.addClassRules('datepicker', {
		validDate: true
	});
}

function setValidationToForms() {

	$('.c-validation-form:not(.validation-container)').each(function () {

		var element = $(this);

		var submitForm = function (form) {

			var validator = this;
			var processData = true;
			var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
			var action = form.action;

			if (form.id === 'add_news_entry' || form.id === 'add_team' || form.id === 'add_date' || form.id === 'add_record' || form.id === 'add_document' || form.id === 'edit_events' || form.id === 'form_contact' || form.id === 'add_training' || form.id === 'add_gymnastic' || form.id === 'add_member' || form.id === 'edit_home') {

				processData = false;
				contentType = false;

				$(form).find('.c-save').attr('disabled', 'disabled');
			}

			getFormData(form).done(function (data) {

				var originalData = data;

				ajax.ajaxCallExtended(action, form.method, data, processData, contentType, null, null, function (data) {

					if (form.id === 'form_contact') {
						toastr.options = {
							"closeButton": true,
							"debug": false,
							"positionClass": "toast-top-center",
							"onclick": null,
							"showDuration": "1000",
							"hideDuration": "1000",
							"timeOut": "5000",
							"extendedTimeOut": "1000",
							"showEasing": "swing",
							"hideEasing": "linear",
							"showMethod": "fadeIn",
							"hideMethod": "fadeOut"
						}

						if (data === '') {
							toastr.success(trans('sv-jedesheim.send_mail_success_desc'), trans('sv-jedesheim.send_mail_success'));
							utils.resetForm($(form).parent());
						} else {
							toastr.error(trans('sv-jedesheim.send_mail_error_desc'), trans('sv-jedesheim.send_mail_error'));
						}

						$(form).find('.c-save').removeAttr('disabled');
					} else {
						if (document.location.href === data['intended']) {
							location.reload();
						} else {
							document.location.href = data['intended'];
						}
					}
				});
			});
		}

		var showInformationBox = function (form) {
			$(form.target).parents('.tt-content-detail').find('.tt-save').removeClass('disabled');
			showValidationMessage();
		}

		$(this).validate({

			debug: false,

			errorElement: 'span', //default input error message container

			errorClass: 'help-block help-block-error', // default input error message class

			focusInvalid: false, // do not focus the last invalid input

			ignore: getIgnore(element),

			rules: getRules(element),

			messages: getMessages(element),

			submitHandler: submitForm,

			invalidHandler: showInformationBox,

			errorPlacement: function (error, element) {
				if (element.is(':checkbox')) {
					error.insertAfter(element.closest(".md-checkbox-list, .md-checkbox-inline, .checkbox-list, .c-checkbox-list, .checkbox-inline"));
				} else if (element.is(':radio')) {
					error.insertAfter(element.closest(".md-radio-list, .md-radio-inline, .radio-list,.radio-inline"));
				} else {
					element.parent().append(error);
				}
			},

			highlight: function (element, errorClass, validClass) {
				$(element).closest('.form-group').addClass('has-error'); // set error class to the control group
			},

			unhighlight: function (element, errorClass, validClass) {
				$(element).closest('.form-group').removeClass('has-error'); // set error class to the control group
			}
		});

		$(this).addClass("validation-container");
	});
}

function getFormData(form) {

	return $.Deferred(function (defer) {
		var data = utils.serializeFormData(form);

		if (form.id === 'add_news_entry' || form.id === 'add_team') {
			$.each($(form).find('.c-file-upload,.c-files-upload'), function(i, element) {
				var files = $(this)[0].files;
				for (var i = 0; i < files.length; i++) {
					data.append($(this).attr('name'), files[i]);
				}
			});
		} else if (form.id === 'add_date' || form.id === 'add_record' || form.id === 'add_document' || form.id === 'edit_events') {
			if ($(form).find('[name="file_upload"]')[0].files.length) {
				data.append('file_upload', $(form).find('[name="file_upload"]')[0].files[0]);
			}
		}

		defer.resolve(data);

	}).promise();
}

function showValidationMessage() {

	toastr.options = {
		"closeButton": false,
		"debug": false,
		"positionClass": "toast-top-right",
		"onclick": null,
		"showDuration": "1000",
		"hideDuration": "1000",
		"timeOut": "5000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	toastr.error(trans('sv-jedesheim.validation_message'), trans('sv-jedesheim.validation'));
}

function getRules(element) {

	var rules = {};

	if (element[0].id === "add_news_entry") {
		rules = {
			news_date: {
				required: true
			},
			news_title: {
				required: true
			},
			news_description: {
				required: true
			}
		};
	} else if (element[0].id === "add_team") {
		rules = {
			team_name: {
				required: true
			},
			team_division: {
				required: true
			},
			team_description: {
				required: true
			},
			team_position: {
				required: true,
				digits: true,
				min: 1
			},
			team_link: {
				requiredWhenElementFilled: ['[name="team_link_description"]'],
				url: true
			},
			team_link_description: {
				requiredWhenElementFilled: ['[name="team_link"]']
			},
			team_link_alternative: {
				requiredWhenElementFilled: ['[name="team_link_alternative_description"]'],
				url: true
			},
			team_link_alternative_description: {
				requiredWhenElementFilled: ['[name="team_link_alternative"]']
			}
		};
	} else if (element[0].id === "add_date") {
		rules = {
			date_title: {
				required: true
			},
			date_table: {
				required: true
			},
			date_position: {
				required: true,
				digits: true,
				min: 1
			},
			date_link: {
				requiredWhenElementFilled: ['[name="date_link_description"]'],
				url: true
			},
			date_link_description: {
				requiredWhenElementFilled: ['[name="date_link"]']
			},
		};
	} else if (element[0].id === "add_record") {
		rules = {
			record_title: {
				required: true
			},
			record_table: {
				required: true
			},
			record_position: {
				required: true,
				digits: true,
				min: 1
			}
		};
	} else if (element[0].id === "add_document") {
		rules = {
			document: {
				requiredWhenElementFilled: ['[name="document_description"]'],
				requireFromGroup: [1, '.c-document-group']
			},
			document_description: {
				requiredWhenElementFilled: ['[name="document"]']
			},
			link: {
				requiredWhenElementFilled: ['[name="link_description"]'],
				requireFromGroup: [1, '.c-document-group'],
				url: true
			},
			link_description: {
				requiredWhenElementFilled: ['[name="link"]']
			},
			position: {
				required: true,
				digits: true,
				min: 1
			}
		};
	} else if (element[0].id === "add_training") {
		rules = {
			training_day_and_time: {
				required: true
			},
			training_location1: {
				required: true
			},
			training_address: {
				required: true
			},
			training_position: {
				required: true,
				digits: true,
				min: 1
			}
		};
	} else if (element[0].id === "form_contact") {
		rules = {
			contact_name: {
				required: true
			},
			email: {
				required: true,
				email: true
			},
			contact_message: {
				required: true
			},
			contact_privacy: {
				required: true
			}
		};
	} else if (element[0].id === "add_member") {
		rules = {
			member_name: {
				required: true
			},
			member_capacity: {
				required: true
			},
			member_icon: {
				required: true
			},
			member_position: {
				required: true,
				digits: true,
				min: 1
			},
			member_email: {
				email: true
			}
		};
	} else if (element[0].id === "edit_home") {
		rules = {
			home_title: {
				required: true
			},
			home_title_desc: {
				required: true
			},
			home_link: {
				required: true,
				url: true
			},
			home_link_text: {
				required: true
			}
		};
	} else if (element[0].id === "edit_events") {
		rules = {
			event_date: {
				required: true
			},
			event_desc: {
				required: true
			}
		};
	}

	return rules;
}

function getMessages(element) {

	return {
		news_date: {
			required: Lang.get('sv-jedesheim.required_date')
		},
		news_title: {
			required: Lang.get('sv-jedesheim.required_title')
		},
		news_description: {
			required: Lang.get('sv-jedesheim.required_description')
		},
		team_division: {
			required: Lang.get('sv-jedesheim.required_team_division')
		},
		team_description: {
			required: Lang.get('sv-jedesheim.required_team_description')
		},
		team_name: {
			required: Lang.get('sv-jedesheim.required_team_name')
		},
		team_position: {
			required: Lang.get('sv-jedesheim.required_position'),
			digits: Lang.get('sv-jedesheim.positiv_integer'),
			min: Lang.get('sv-jedesheim.positiv_integer')
		},
		team_link: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_filled'),
			url: Lang.get('sv-jedesheim.valid_link')
		},
		team_link_description: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_description_filled')
		},
		team_link_alternative: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_filled'),
			url: Lang.get('sv-jedesheim.valid_link')
		},
		team_link_alternative_description: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_description_filled')
		},
		date_title: {
			required: Lang.get('sv-jedesheim.required_title')
		},
		date_table: {
			required: Lang.get('sv-jedesheim.required_date_table')
		},
		date_link: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_filled'),
			url: Lang.get('sv-jedesheim.valid_link')
		},
		date_link_description: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_description_filled')
		},
		date_position: {
			required: Lang.get('sv-jedesheim.required_position'),
			digits: Lang.get('sv-jedesheim.positiv_integer'),
			min: Lang.get('sv-jedesheim.positiv_integer')
		},
		document: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_document_filled')
		},
		document_description: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_description_filled')
		},
		link: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_filled'),
			url: Lang.get('sv-jedesheim.valid_link')
		},
		link_description: {
			requiredWhenElementFilled: Lang.get('sv-jedesheim.required_when_link_description_filled')
		},
		contact_name: {
			required: Lang.get('sv-jedesheim.required_contact_name')
		},
		contact_privacy: {
			required: Lang.get('sv-jedesheim.required_privacy')
		},
		email: {
			required: Lang.get('sv-jedesheim.required_email'),
			email: Lang.get('sv-jedesheim.invalid_email')
		},
		contact_message: {
			required: Lang.get('sv-jedesheim.required_message')
		},
		training_day_and_time: {
			required: Lang.get('sv-jedesheim.required_day_and_time')
		},
		training_location1: {
			required: Lang.get('sv-jedesheim.required_location1')
		},
		training_address: {
			required: Lang.get('sv-jedesheim.required_address')
		},
		training_position: {
			required: Lang.get('sv-jedesheim.required_position'),
			digits: Lang.get('sv-jedesheim.positiv_integer'),
			min: Lang.get('sv-jedesheim.positiv_integer')
		},
		member_name: {
			required: Lang.get('sv-jedesheim.required_member_name')
		},
		member_capacity: {
			required: Lang.get('sv-jedesheim.required_capacity')
		},
		member_icon: {
			required: Lang.get('sv-jedesheim.required_icon')
		},
		member_email: {
			email: Lang.get('sv-jedesheim.invalid_email')
		},
		member_position: {
			required: Lang.get('sv-jedesheim.required_position'),
			digits: Lang.get('sv-jedesheim.positiv_integer'),
			min: Lang.get('sv-jedesheim.positiv_integer')
		},
		home_title: {
			required: Lang.get('sv-jedesheim.required_home_title')
		},
		home_title_desc: {
			required: Lang.get('sv-jedesheim.required_home_title_desc')
		},
		home_link: {
			required: Lang.get('sv-jedesheim.required_home_link'),
			url: Lang.get('sv-jedesheim.valid_link')
		},
		home_link_text: {
			required: Lang.get('sv-jedesheim.required_home_link_text')
		}
	}
}

function getIgnore(element) {

	var ignore = ":hidden:not(select.c-select2,input.c-select2)";

	return ignore;
}

module.exports.validatorMethods = validatorMethods;
module.exports.setValidationToForms = setValidationToForms;
module.exports.getRules = getRules;
module.exports.showValidationMessage = showValidationMessage;